import React, { Component } from "react";
import {CardBody} from "reactstrap";
import { Card, CardTitle } from "reactstrap";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import base_URL from "../../base_URL";
import { Container } from "@material-ui/core";

class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
     data:[]
    };

    this.loadData = this.loadData.bind(this);
  }

  

  loadData = async () => {
    await Axios.get(`${base_URL}/admin/data`)
    .then((response) => {
      this.setState({
        data: response.data,
      });
    });
  };

  componentDidMount() {
   
    this.loadData();
  }

  render() {
    if (localStorage.getItem("Admin1token") == null)
    return <Redirect to="/login" />;


 
    return (
      <Container  id="container">
        <Card body style={{ margin: "20px" }} id="Card">
          <CardTitle>
            <h1>DashBoard</h1>
          </CardTitle>
          <CardBody>
              <ui>
              
              <li>No of User {this.state.data.user}</li>
              <li>No of Themes {this.state.data.theme}</li>
              <li>No of Services {this.state.data.service}</li>
              <li>No of NeededTheme {this.state.data.need}</li>
              </ui>
              
              
          </CardBody>
        </Card>
       </Container>
    );
  }
}


export default DashBoard;
